if (!window.hasOwnProperty('appModules')) {
    window.appModules = {};
}

window.appModules.Shopcart = function () {
    var self = this;
    var data = {};
    var orderData = {};
    var orderNumber = 0;
    var step = 1;
    var promocode = false;
    var showMinCost = false;
    var isUsedPhotoprintPromoDiscount = false;

    const YANDEX_MAP_TYPE = 0;
    const GOOGLE_MAP_TYPE = 1;
    let currentMapType = YANDEX_MAP_TYPE;

    var deliveryData = {
        id: 0,
        service_id: 0,
        region_id: 0,
        city: '',
        country: '',
        point_id: 0
    };

    var companyAddressPayments = [];

    var pointsCountries = [];

    var addressId = 0;

    var photoPrintItems = {
        count: {}
    };

    var shop = {
        cost: 0,
    }

    var PHOTOPRINT_PRODUCT_GROUP = 1;
    var PHOTOBOOK_PRODUCT_GROUP = 2;
    var SOUVENIR_PRODUCT_GROUP = 3;
    var FILE_PRODUCT_GROUP = 4;
    var INTERIOR_PRODUCT_GROUP = 5;
    var CALENDAR_PRODUCT_GROUP = 6;
    var POLYGRAPHY_PRODUCT_GROUP = 7;
    var DESIGNBOOK_PRODUCT_GROUP = 8;
    var INVOICE_PRODUCT_GROUP = 9;
    var SHOP_PRODUCT_GROUP = 10;

    var PICKUP_DELIVERY_ID = '1';
    var COURIER_DELIVERY_ID = '2';
    var MAILRUSSIA_DELIVERY_ID = '3';
    var NOVAPOSHTA_DELIVERY_ID = '4';
    var LATVIJASPASTS_DELIVERY_ID = '6';
    var POINTS_DELIVERY_ID = '7';

    var DELIVERY_SERVICE_CDEK_ID = '5';
    var DELIVERY_SERVICE_OZON_ID = '9';
    var DELIVERY_SERVICE_EUROPOST_ID = '10';

    var PHOTOCENTER_SERVICE_ID = '1';

    var CARD_PAYMENT_ID = 3;

    var PROFITABLE_TYPE_PROMOCODE = '1';
    var SUM_TYPE_PROMOCODE = '2';

    var PAYMENT_ONLINE_ID = 2;

    var promocode_desc = {
        [PROFITABLE_TYPE_PROMOCODE]: 'В загруженных пакетах в услуге  "Печать фотографий" будет использован более выгодный для Вас вариант скидки. По промокоду (рассчитывается от базовой розничной цены), или скидка от количества фотографий.',
    }

    var templates = {
        items: $('#items-template').html(),
        promocodes: $('#promocodes-template').html(),
        cost_1: $('#cost_1-template').html(),
        payments: $('#payments-template').html(),
        user: $('#user-template').html(),
        delivery: $('#delivery-template').html(),
        margins: $('#margins-template').html(),
        cost_2: $('#cost_2-template').html(),
        number: $('#number-template').html(),
        use_samples: $('#use-samples-template').html()
    };

    var existProductGroup = {};

    function init() {
        self.loader.show(Yii.t('Application initialization'));
        $.get('/shopcart/init', function (response) {
            if (response.hasOwnProperty('error')) {
                self.dialog.show('message', {message: response.error});
            } else {
                data = response;
                initData();
                renderItems();
                renderPromocodes();
            }
            self.loader.hide();
        }, 'json');
    }

    function initData() {
        orderData = {
            items: {},
            user: _.isArray(data.user) ? {} : data.user,
            address_id: data.address_id,
            payment: 0,
            delivery: {},
            margins: {},
            comment: '',
            user_address: {},
            promocode: 0,
            use_samples: 0,
            send_sms: 1,
            send_action_emails: 0,
            delivery_is_fragile: 0,
            accept_rules: 1,
            writeoff_bonus: 0
        };

        addressId = data.address_id;

        pointsCountries = getDeliveryPointsCountries();

        /** по умолчанию выбираем первый тип доставки */

        var countDeliveries = Object.keys(data.deliveries).length;
        if (countDeliveries > 0) {
            const values = Object.values(data.deliveries);
            const firstDelivery = values.reduce((min, currentItem) => {
                const currentPosition = parseInt(currentItem.position);
                if (currentPosition < min.position) {
                    return currentItem;
                } else {
                    return min;
                }
            });

            setDelivery({
                id: firstDelivery.delivery_id
            });
        }

        /** параметры доставки, если уже были заказы */

        if (data.last_delivery) {
            const deliveryId = data.last_delivery.id;
            const serviceId = data.last_delivery.service_id;
            const pointId = data.last_delivery.point_id;
            const point = data.points[pointId];

            setDelivery({
                id: deliveryId ? String(deliveryId) : 0,
                service_id: serviceId ? String(serviceId) : 0,
                city: point ? point.city : '',
                country: point ? point.country : '',
                point_id: point ? point.id : 0,
            });
        }

        /** для самовывоза выбор адреса, если он один */

        var countAddresses = Object.keys(data.addresses).length;
        if (countAddresses === 1 && data.deliveries.hasOwnProperty(PICKUP_DELIVERY_ID) && deliveryData.id === PICKUP_DELIVERY_ID) {
            setDelivery({
                id: PICKUP_DELIVERY_ID,
                point_id:  addressId,
            });
        }

        _.forEach(data.items, function (item) {
            orderData.items[item.id] = parseInt(item.count);
        });

        photoPrintItems.count = findPhotoPrintCountItems(data.items);

        shop.cost = calculateShopCost(data.items);

        initUserAutoPromocode();
    }

    function initUserAutoPromocode() {
        if (data.user_promocode) {
            checkPromocode(data.user_promocode.name)
        }
    };

    function findPhotoPrintCountItems(items) {
        var count = {};

        _.forEach(items, function (item) {
            if (parseInt(item.product_group_id) !== PHOTOPRINT_PRODUCT_GROUP) {
                return;
            }

            var project = data.photo.projects[item.data.project_id];

            if (!_.isObject(project)) {
                return;
            }

            var photos = project.photoProjectImages;

            count = findPhotoPrintProjectCountItems(count, photos);
        });

        return count;
    }

    function calculateShopCost(items) {
        var cost = 0;

        _.forEach(items, function (item) {
            if (parseInt(item.product_group_id) !== SHOP_PRODUCT_GROUP) {
                return;
            }

            var product = data.shop.products[item.data.product_id];
            if (!_.isObject(product)) {
                return;
            }

            var productCost = parseFloat(product.cost);

            var minPriceGroupCost = 0;
            product.productPrices.forEach(function (price) {
                if (parseFloat(price.priceGroup.cost) > minPriceGroupCost) {
                    return;
                }

                minPriceGroupCost = parseFloat(price.priceGroup.cost);
                productCost = parseFloat(price.cost);
            });

            cost += productCost * item.count;
        });

        return cost;
    }

    function getCost() {
        var cost = 0;

        _.forEach(orderData.items, function (count, key) {
            var item = data.items[key];
            var itemCost = 0;

            switch (parseInt(item.product_group_id)) {
                case PHOTOBOOK_PRODUCT_GROUP:
                case INTERIOR_PRODUCT_GROUP:
                case INVOICE_PRODUCT_GROUP:
                    itemCost = item.amount * count;
                    break;
                case SOUVENIR_PRODUCT_GROUP:
                    itemCost = getSouvenirCost(item.data, count);
                    break;
                case DESIGNBOOK_PRODUCT_GROUP:
                    itemCost = parseFloat(item.amount);
                    break;
                case PHOTOPRINT_PRODUCT_GROUP:
                    itemCost = getPhotoprintCost(item.data.project_id);
                    break;
                case SHOP_PRODUCT_GROUP:
                    itemCost = getShopProductCost(item.data, count);
                    break;
            }

            itemCost += getItemMarginCost(item.product_group_id, itemCost) 

            cost += itemCost;
        });

        return cost;
    }

    function getItemMarginCost(productGroupId, itemCost) {
        let cost = 0;
        if (
            orderData.margins.hasOwnProperty(productGroupId)
            && orderData.margins[productGroupId] !== 0
        ) {
            var marginId = orderData.margins[productGroupId];
            cost = itemCost * (data.margins[marginId].percent / 100);
        }

        return cost;
    }

   async function renderCost2() {
        var cost = 0;
        var margin_cost = 0;
        var promocodeValue = 0;
        isUsedPhotoprintPromoDiscount = false;

        // если в корзине нет товаров кроме фотопечати  и указана сумма промокода (исп. при расчете более выгодной скидки фотопечати)
        var usePromocodeProfitable = checkItemsUseProfitableSum();
        
        var i, item, itemCost;
        for (i in orderData.items) {
            item = data.items[i];
            itemCost = 0;

            switch (parseInt(item.product_group_id)) {
                case PHOTOBOOK_PRODUCT_GROUP:
                case INTERIOR_PRODUCT_GROUP:
                case INVOICE_PRODUCT_GROUP:
                    itemCost = item.amount * orderData.items[i];
                    break;
                case DESIGNBOOK_PRODUCT_GROUP:
                    itemCost = parseFloat(item.amount);
                    break;
                case SOUVENIR_PRODUCT_GROUP:
                    itemCost = getSouvenirCost(item.data, orderData.items[i]);
                    break;
                case PHOTOPRINT_PRODUCT_GROUP:
                    itemCost = getPhotoprintCost(item.data.project_id);
                    break;
                case SHOP_PRODUCT_GROUP:
                    itemCost = getShopProductCost(item.data, orderData.items[i]);
                    break;
            }

            // check promocode
            var promocodeItem = getPromoCodeCost(promocodeValue, item, itemCost, usePromocodeProfitable);
            promocodeValue = promocodeItem.value;
            itemCost = promocodeItem.cost;

            // check margins
            itemMarginCost = getItemMarginCost(item.product_group_id, itemCost);
            itemCost += itemMarginCost;

            margin_cost += itemMarginCost;

            cost += itemCost;
        }

        // writeoff abs promocode value
        if (promocodeValue !== 0) {
            cost -= promocodeValue;
        }

        // check min cost
        var minCost = parseFloat(data.company.min_cost);

        if (cost < minCost) {
            cost = minCost;
        }

        // calc bonuses
        var percent, avalaible_bonus = 0;
        if (data.hasOwnProperty('bonuses')) {
            percent = getPercentBonus();
            avalaible_bonus = percent.writeoff / 100 * cost;
            avalaible_bonus = avalaible_bonus > parseFloat(data.bonuses.balance) ? parseFloat(data.bonuses.balance) : avalaible_bonus;
        }

        if (orderData.writeoff_bonus === 1) {
            cost -= avalaible_bonus;
        }


        // calc delivery cost
        var delivery_cost = 0;
        var delivery = data.deliveries[deliveryData.id];

        if (deliveryData.id !== 0 && parseInt(delivery.cost) !== 0) {
            delivery_cost += parseFloat(delivery.cost);
        }

        if (cost >= delivery.min_order_cost && parseInt(delivery.min_order_cost) !== 0) {
            delivery_cost = 0;
        }

        // check delivery cost for address
        if (data.addresses.hasOwnProperty(deliveryData.point_id)) {
            var address = data.addresses[deliveryData.point_id];
            if (parseInt(address.delivery_cost) !== 0) {
                delivery_cost += parseFloat(address.delivery_cost);
            }

            if (cost >= address.delivery_min_order_cost && parseInt(address.delivery_min_order_cost) !== 0) {
                delivery_cost = 0;
            }
        }
        // add service or city cost
        if (deliveryData.id === POINTS_DELIVERY_ID && deliveryData.point_id !== 0) {
            var service = data.delivery_services[data.points[deliveryData.point_id].service_id];

            if (service.service_id !== 0 && parseInt(service.cost) !== 0) {
                const servicesName = {
                    [DELIVERY_SERVICE_OZON_ID] : 'ozon',
                    [DELIVERY_SERVICE_EUROPOST_ID] : 'europost',
                    [DELIVERY_SERVICE_CDEK_ID] : 'cdek',
                }
                
                if (servicesName.hasOwnProperty(service.service_id) && parseInt(service.send_request_calculate_cost) !== 0) {
                    try {
                        let pointId = deliveryData.point_id.split('_')[1];
                        let amount = parseInt(orderData.payment) === PAYMENT_ONLINE_ID ? 0 : cost;
                        let response = await fetch(`delivery/${servicesName[service.service_id]}/calculate?pointId=${pointId}&isFragile=${orderData.delivery_is_fragile}&amount=${amount}`);
                        let costDeliveryService = await response.json();

                        delivery_cost += parseFloat(costDeliveryService.cost);
                        delivery_cost += parseFloat(service.add_to_cost);
                      } catch(err) {
                        delivery_cost += parseFloat(service.cost);
                        console.log(err);
                      }
                }else {
                    delivery_cost += parseFloat(service.cost);
                }
            }

            if (cost >= service.min_order_cost && parseInt(service.min_order_cost) !== 0) {
                delivery_cost = 0;
            }

            var deliveryCity = getDeliveryCity(deliveryData.city, service.service_id);
            if (deliveryCity !== false) {
                delivery_cost = parseFloat(deliveryCity.cost);
            }

            if (deliveryCity !== false && cost >= deliveryCity.min_order_cost && parseInt(deliveryCity.min_order_cost) !== 0) {
                delivery_cost = 0;
            }
        }

        if (deliveryData.id === COURIER_DELIVERY_ID && parseInt(deliveryData.service_id) !== 0) {
            // add service cost and add service courier cost
            var service = data.delivery_services[deliveryData.service_id];

            const servicesName = {
                [DELIVERY_SERVICE_OZON_ID] : 'ozon',
                [DELIVERY_SERVICE_EUROPOST_ID] : 'europost',
                [DELIVERY_SERVICE_CDEK_ID] : 'cdek',
            }

            if (deliveryData.point_id > 0) {
                try {
                    let pointId = deliveryData.point_id;
                    let amount = parseInt(orderData.payment) === PAYMENT_ONLINE_ID ? 0 : cost;
                    let response = await fetch(`delivery/${servicesName[service.service_id]}/calculate?pointId=${pointId}&isFragile=${orderData.delivery_is_fragile}&amount=${amount}`);
                    let costDeliveryService = await response.json();

                    delivery_cost += parseFloat(costDeliveryService.cost);
                    delivery_cost += parseFloat(service.add_to_cost);
                } catch(err) {
                    //delivery_cost += parseFloat(service.cost);
                    //console.log(err);
                    console.log(err);
                }
            }

            if (cost < parseInt(service.min_order_cost) || parseInt(service.min_order_cost) === 0) {
                delivery_cost += parseFloat(service.cost);
                delivery_cost += parseFloat(service.courier_cost);
            }

            var deliveryCity = getDeliveryCity(deliveryData.city, service.service_id);
            if (deliveryCity !== false) {
                delivery_cost = parseFloat(deliveryCity.cost);
                delivery_cost += parseFloat(service.courier_cost);
            }

            if (deliveryCity !== false && cost >= deliveryCity.min_order_cost && parseInt(deliveryCity.min_order_cost) !== 0) {
                delivery_cost = 0;
            }

            // add region cost
            if (deliveryData.service_id === PHOTOCENTER_SERVICE_ID) {
                var region = data.courier_regions[deliveryData.region_id];
                if (cost < parseInt(region.min_order_cost) || parseInt(region.min_order_cost) === 0) {
                    delivery_cost += parseFloat(region.cost);
                }
            }

        }

        /** для сдэк округляем в большую сторону стоимость доставки */
        if (Number(deliveryData.service_id) === Number(DELIVERY_SERVICE_CDEK_ID)) {
            delivery_cost = Math.ceil(delivery_cost);
        }

        const total_cost = cost + delivery_cost;
        let total_cost_info = 0; 

        const payment = orderData.payment;
        if (companyAddressPayments.hasOwnProperty(payment)) {
            const addressPayment = companyAddressPayments[payment];
            const additionalPercent = parseFloat(addressPayment.additional_percent);
            if (additionalPercent !== 0.00) {
                total_cost_info = total_cost + (total_cost / 100 * additionalPercent);
            }
        }

        var templateData = {
            cost: cost.toFixed(2),
            total_cost: total_cost.toFixed(2),
            delivery_cost: delivery_cost.toFixed(2),
            is_show_delivery: delivery_cost !== 0,
            is_show_margin: margin_cost !== 0,
            margin_cost: margin_cost.toFixed(2),
            is_fragile: orderData.delivery_is_fragile,
            show_is_fragile: false,
            show_total_cost_info: total_cost_info !== 0,
            total_cost_info: total_cost_info.toFixed(2),
            // show_is_fragile: deliveryData.service_id === DELIVERY_SERVICE_EUROPOST_ID,
        };

        if (data.hasOwnProperty('bonuses')) {
            templateData.is_show_bonuses = true;
            templateData.balance = data.bonuses.balance;
            templateData.avalaible_bonus = avalaible_bonus.toFixed(2);
            templateData.bonus_order = (percent.income / 100 * cost).toFixed(2);
            templateData.writeoff_bonus = orderData.writeoff_bonus;
        }

        var html = self.templater.render(templates.cost_2, templateData);
        $('.cost-2').html(html);
    }

    function getPromoCodeCost(promoCodeValue, item, itemCost, isUseProfitablePromocode) {
        if (promocode === false) {
            return { cost : itemCost, value: promoCodeValue};
        }

        /** TODO: сделан хак: при создании фотокниги через архив или ссылку
         * воспринимать заказ как пакетная загрузка
         * **/
        const hasArchive = item.data.link || item.data.archive;
        const itemProductGroupId = hasArchive ? DESIGNBOOK_PRODUCT_GROUP : item.product_group_id;

        var productGroup = _.find(promocode.product_groups, function (productGroupItem) {
            return parseInt(productGroupItem.product_group_id) === parseInt(itemProductGroupId);
        });

        if (_.isObject(productGroup)) {
            switch (parseInt(itemProductGroupId)) { 
                case PHOTOPRINT_PRODUCT_GROUP:
                    return calcPromoCodeCostByTypePromocode(promoCodeValue, itemCost, item, isUseProfitablePromocode);
                default: 
                    promoCodeValue = calcPromoCodeCost(promoCodeValue, itemCost);
                    return { cost : itemCost, value: promoCodeValue};
            }
        }

        var projectId, project, promoCodeItem;
        switch (parseInt(itemProductGroupId)) {
            case PHOTOBOOK_PRODUCT_GROUP:
                promoCodeItem = _.find(promocode.product_groups, function (productGroupItem) {
                    return parseInt(productGroupItem.photobook_type_id) === parseInt(item.data.book_types);
                });

                if (_.isObject(promoCodeItem)) {
                    promoCodeValue = calcPromoCodeCost(promoCodeValue, itemCost);
                    return { cost : itemCost, value: promoCodeValue};
                }
            case DESIGNBOOK_PRODUCT_GROUP:
                /** создание через архив аналогично обычным фотокнигам,
                 * у пакетной другой формат и другая обработка
                 */
                if (hasArchive) {
                    promoCodeItem = _.find(promocode.product_groups, function (productGroupItem) {
                        return parseInt(productGroupItem.photobook_type_id) === parseInt(item.data.book_types);
                    });
    
                    if (_.isObject(promoCodeItem)) {
                        promoCodeValue = calcPromoCodeCost(promoCodeValue, itemCost);
                        return { cost : itemCost, value: promoCodeValue};
                    }
                } else {
                    const promoPhotobookTypeIds = Object.values(promocode.product_groups).map(
                        (productGroupItem) => parseInt(productGroupItem.photobook_type_id)
                    );
                    const books = (item.data.books || []).filter(
                        (book) => promoPhotobookTypeIds.includes(parseInt(book.book_types))
                    );

                    if (books.length) {
                        const booksCost = books.reduce((cost, item) => cost + item.cost, 0);

                        promoCodeValue = calcPromoCodeCost(promoCodeValue, booksCost);
                        return { cost : itemCost, value: promoCodeValue};
                    }
                }
                break;
            case SOUVENIR_PRODUCT_GROUP:
                var categoryID = getSouvenirCategoryID(item.data);
                var productID = getSouvenirProductID(item.data);

                promoCodeItem = _.find(promocode.product_groups, function (productGroupItem) {
                    return parseInt(productGroupItem.souvenir_category_id) === parseInt(categoryID);
                });

                if (!_.isObject(promoCodeItem)) {
                    promoCodeItem = _.find(promocode.product_groups, function (productGroupItem) {
                        return parseInt(productGroupItem.souvenir_product_id) === parseInt(productID);
                    });
                }

                if (_.isObject(promoCodeItem)) {
                    promoCodeValue = calcPromoCodeCost(promoCodeValue, itemCost);
                    return { cost : itemCost, value: promoCodeValue};
                }
                break;
            case INTERIOR_PRODUCT_GROUP:
                projectId = item.data.project_id;
                project = data.interior.projects[projectId];
                if (!_.isObject(project)) {
                    break;
                }

                promoCodeItem = _.find(promocode.product_groups, function (productGroupItem) {
                    return parseInt(productGroupItem.interior_product_id) === parseInt(project.product_id);
                });

                if (_.isObject(promoCodeItem)) {
                    promoCodeValue = calcPromoCodeCost(promoCodeValue, itemCost);
                    return { cost : itemCost, value: promoCodeValue};
                }
                break;
        }

        return { cost : itemCost, value: promoCodeValue};
    }

    function calcPromoCodeCost(promoCodeValue, itemCost)
    {
        if (parseInt(promocode.discount_percent) === 0) {
            promoCodeValue = parseFloat(promocode.discount_value);
        } else {
            promoCodeValue += itemCost * parseInt(promocode.discount_percent) / 100;
        }

        return promoCodeValue;
    }

    function calcPromoCodeCostByTypePromocode(promoCodeValue, itemCost, item, usePromocodeProfitable)
    {
        var costWithDiscount;
        var currentPromoCodeValue = 0;

        switch (promocode.type) {
            case PROFITABLE_TYPE_PROMOCODE:
                promocode.description = promocode_desc[PROFITABLE_TYPE_PROMOCODE];

                //цена со скидкой от кол-ва
                costWithDiscount = getPhotoprintCost(item.data.project_id, false);
                
                if (!usePromocodeProfitable) {
                    itemCost = costWithDiscount;
                    break;
                }
                
                if (parseInt(promocode.discount_percent) === 0) {
                    currentPromoCodeValue = parseFloat(promocode.discount_value);
                    //если промокод суммы уже использовался, то вернуть стоимость  (со скидкой от кол-ва)
                    if (isUsedPhotoprintPromoDiscount) {
                        return { cost : costWithDiscount, value: promocode.discount_value};
                    }
                } else {
                    currentPromoCodeValue = itemCost * parseInt(promocode.discount_percent) / 100;
                }
                
                cost = itemCost - currentPromoCodeValue;
                if (cost > costWithDiscount) {
                    currentPromoCodeValue = 0;
                    itemCost = costWithDiscount;
                }

                if (parseInt(promocode.discount_percent) === 0) {
                    promoCodeValue = parseFloat(currentPromoCodeValue);
                } else {
                    promoCodeValue +=currentPromoCodeValue;
                }

                if (parseInt(currentPromoCodeValue) !== 0 && parseInt(promocode.discount_value) !== 0) {
                    isUsedPhotoprintPromoDiscount = true;
                }
                break;
            case SUM_TYPE_PROMOCODE: 
                if (parseInt(promocode.discount_percent) === 0) {
                    promoCodeValue = parseFloat(promocode.discount_value);
                } else {
                    promoCodeValue += itemCost * parseInt(promocode.discount_percent) / 100;
                }
                break;
        }

        return { cost : itemCost, value: promoCodeValue};
    }

    function isUsePromoCodeForPhotoprint() {
        if (promocode === false) {
            return false;
        }

        var productGroup = _.find(promocode.product_groups, function (productGroupItem) {
            return parseInt(productGroupItem.product_group_id) === PHOTOPRINT_PRODUCT_GROUP;
        });

        if (promocode.type === SUM_TYPE_PROMOCODE) {
            return false;
        }

        return _.isObject(productGroup);
    }


    function getDeliveryCity(city, serviceId) {
        var deliveryCities = data.delivery_cities;
        for (var i in deliveryCities) {
            if (deliveryCities[i].name === city && parseInt(deliveryCities[i].service_id) === parseInt(serviceId)) {
                return deliveryCities[i];
            }
        }

        return false;
    }

    function getPhotoprintCost(projectId, withPromocode = true) {
        var cost = 0;
        var project = data.photo.projects[projectId];

        if (!_.isObject(project)) {
            return cost;
        }

        var isUsePromoCode = withPromocode ? isUsePromoCodeForPhotoprint() : false;
        var photos = project.photoProjectImages;
        var address = data.addresses[addressId];
        var prices = data.photo.prices;
        var discounts = data.photo.discounts;
        var corrections = data.photo.corrections;
        var totalItems = photoPrintItems.count;
        var items = findPhotoPrintProjectCountItems({}, photos);
        var countFiles = _.size(photos);
        var i;
        var correction = {
            cost: 0
        };

        var correctionId = getPhotoPrintCorrectionFromPhotos(photos);
        for (i in corrections) {
            if (correctionId === parseInt(corrections[i].correction_id)) {
                correction = corrections[i];
                break;
            }
        }

        _.forEach(items, function (paperItems, itemPaperId) {
            _.forEach(paperItems, function (itemCount, itemFormatId) {
                var itemCost = 0;
                var formatCount = 0;

                var price = _.find(prices, function (item) {
                    return parseInt(item.group) === parseInt(address.price)
                        && parseInt(item.format) === parseInt(itemFormatId)
                        && parseInt(item.paper_id) === parseInt(itemPaperId)
                });

                if (!isUsePromoCode) {
                    for (i in totalItems) {
                        if (!totalItems[i].hasOwnProperty(itemFormatId) || i !== itemPaperId) {
                            continue;
                        }

                        formatCount += totalItems[i][itemFormatId];
                    }

                    var formatDiscounts = _.filter(discounts, {
                        product_type_id: itemFormatId,
                        paper_id: itemPaperId
                    });

                    if (_.isArray(formatDiscounts)) {
                        var formatDiscountItem = null;
                        _.forEach(formatDiscounts, function (formatDiscount) {
                            if (formatDiscount.count_min > formatCount) {
                                return true;
                            }

                            if (formatDiscountItem === null || parseInt(formatDiscount.count_min) > parseInt(formatDiscountItem.count_min)) {
                                formatDiscountItem = formatDiscount;
                            }
                        });

                        if (formatDiscountItem !== null) {
                            var discountCost;
                            
                            if (parseFloat(formatDiscountItem.discount_value) !== 0) {
                                discountCost = formatDiscountItem.discount_value;
                            } else {
                                discountCost = (100 - formatDiscountItem.discount_percent) / 100 * price.price;
                                var countAfterDecimal  = parseInt(formatDiscountItem.round_price) ? 1 : 2;
                                discountCost = discountCost.toFixed(countAfterDecimal);
                            }
                            itemCost = parseFloat(itemCount * parseFloat(discountCost));
                        }
                    }
                }

                if (_.isObject(price) && itemCost === 0) {
                    itemCost = parseFloat(itemCount * price.price);
                }

                cost += itemCost;
            });
        });

        cost += parseFloat(correction.cost * countFiles);

        return cost;
    }

    function getPhotoPrintCorrectionFromPhotos(photos) {
        var keys = Object.keys(photos);
        if (keys.length === 0) {
            return null;
        }

        var photo = photos[keys[0]];
        return parseInt(photo.correction_id);
    }

    function findPhotoPrintProjectCountItems(count, photos) {
        _.forEach(photos, function (photo) {
            if (!count.hasOwnProperty(photo.paper_id)) {
                count[photo.paper_id] = {};
            }

            if (count[photo.paper_id].hasOwnProperty(photo.format_id)) {
                count[photo.paper_id][photo.format_id] += parseInt(photo.count);
            } else {
                count[photo.paper_id][photo.format_id] = parseInt(photo.count);
            }
        });

        return count;
    }

    function getSouvenirCost(itemData, count) {
        var cost = 0;
        var price = data.souvenir.price;
        var address = data.addresses[addressId];
        if (!_.isObject(address)) {
            return cost;
        }

        var priceGroupID = address.souvenir_price_group_id;
        var productID = getSouvenirProductID(itemData);

        cost += getSouvenirProductCost(itemData, count, price, priceGroupID, productID);
        cost += getSouvenirCostFromProject(itemData, count, price, priceGroupID, productID);
        cost += getSouvenirCostFromCalculator(itemData, count, price, priceGroupID, productID);
        return cost;
    }

    function getSouvenirProductCost(itemData, count, price, priceGroupID, productID)
    {
        var cost = 0;
        var productCost = 0;
        var lastProductCount = 0;
        price.forEach(function (priceRow) {
            if (parseInt(priceRow.price_group_id) !== parseInt(priceGroupID)) {
                return;
            }

            if (parseInt(priceRow.product_id) !== parseInt(productID)) {
                return;
            }

            if (priceRow.format_id === null && priceRow.count >= lastProductCount && count >= priceRow.count) {
                lastProductCount = priceRow.count;
                productCost = priceRow.cost;
            }
        });

        cost += productCost * count;
        return cost;
    }

    function getSouvenirCostFromProject(itemData, count, price, priceGroupID, productID)
    {
        var cost = 0;

        var project = data.souvenir.projects[itemData.project_id];
        if (!_.isObject(project)) {
            return cost;
        }

        var categoryID = getSouvenirCategoryID(itemData);
        var category = data.souvenir.categories[categoryID];
        if (!_.isObject(category)) {
            return cost;
        }

        var calculateAllWorkAreas = parseInt(category.calc_all_workareas);
        var constructorData = JSON.parse(project.constructor);
        var workareas = constructorData.workareas;
        var formatsCount = {};
        Object.values(workareas).forEach(function (workarea) {
            var formatID = workarea.format.id;

            if (
                !calculateAllWorkAreas
                && Object.keys(workarea.format.layers).length === 0
                && Object.keys(workarea.format.backgrounds).length === 0
                && Object.keys(workarea.format.texts).length === 0
            ) {
                return;
            }

            if (!formatsCount.hasOwnProperty(formatID)) {
                formatsCount[formatID] = 0;
            }

            formatsCount[formatID]++;
        });

        cost = getSouvenirFormatsCost(formatsCount, count, price, priceGroupID, productID);

        return cost;
    }
    
    function getSouvenirCostFromCalculator(itemData, count, price, priceGroupID, productID) {
        var cost = 0;

        if (!itemData.hasOwnProperty('workareas')) {
            return cost;
        }

        var formatsCount = {};
        Object.keys(itemData.workareas).forEach(function (workareaID) {
            var workarea = itemData.workareas[workareaID];
            var formatID = workarea.format_id;
            if (!formatsCount.hasOwnProperty(formatID)) {
                formatsCount[formatID] = 0;
            }

            formatsCount[formatID]++;
        });

        cost = getSouvenirFormatsCost(formatsCount, count, price, priceGroupID, productID);

        return cost;
    }

    function getSouvenirFormatsCost(formatsCount, count, price, priceGroupID, productID) {
        var cost = 0;
        Object.keys(formatsCount).forEach(function (formatID) {
            var formatCount = count;
            var lastFormatCount = 0;
            var formatCost = 0;
            price.forEach(function (priceRow) {
                if (parseInt(priceRow.price_group_id) !== parseInt(priceGroupID)) {
                    return;
                }

                if (parseInt(priceRow.product_id) !== parseInt(productID)) {
                    return;
                }

                if (parseInt(priceRow.format_id) !== parseInt(formatID)) {
                    return;
                }

                if (priceRow.count >= lastFormatCount && formatCount >= priceRow.count) {
                    lastFormatCount = priceRow.count;
                    formatCost = priceRow.cost;
                }
            });
            cost += formatCost * formatCount*formatsCount[formatID];
        });

        return cost;
    }

    function getSouvenirCirculations(itemData, count) {
        var circulations = [];
        var price = data.souvenir.price;
        var address = data.addresses[addressId];
        if (!_.isObject(address)) {
            return circulations;
        }

        var productID = getSouvenirProductID(itemData);
        var priceGroupID = address.souvenir_price_group_id;

        var product = data.souvenir.companyProducts[productID];
        if (!_.isObject(product)) {
            return circulations;
        }

        if (parseInt(product.quantity_from_circulation) === 0) {
            return circulations;
        }

        price.forEach(function (priceRow) {
            if (parseInt(priceRow.price_group_id) !== parseInt(priceGroupID)) {
                return;
            }

            if (parseInt(priceRow.product_id) !== parseInt(productID)) {
                return;
            }

            if (priceRow.format_id === null) {
                circulations.push({
                    count: priceRow.count,
                    is_active: parseInt(priceRow.count) === parseInt(count),
                });
            }
        });

        return circulations;
    }

    function getSouvenirCategoryID(itemData) {
        var categoryID = 0;
        if (itemData.hasOwnProperty('project_id')) {
            var project = data.souvenir.projects[itemData.project_id];
            if (!_.isObject(project)) {
                return categoryID;
            }

            categoryID = project.category_id;
        }

        if (itemData.hasOwnProperty('category_id')) {
            categoryID = itemData.category_id;
        }

        return categoryID;
    }

    function getSouvenirProductID(itemData) {
        var productID = 0;
        if (itemData.hasOwnProperty('project_id')) {
            var project = data.souvenir.projects[itemData.project_id];
            if (!_.isObject(project)) {
                return productID;
            }

            productID = project.product_id;
        }

        if (itemData.hasOwnProperty('product_id')) {
            productID = itemData.product_id;
        }

        return productID;
    }

    function getShopProductCost(itemData, count) {
        var cost = 0;

        var product = data.shop.products[itemData.product_id];
        if (!_.isObject(product)) {
            return cost;
        }

        cost = parseFloat(product.cost);

        var minPriceGroupCost = 0;
        product.productPrices.forEach(function (price) {
            if (
                parseFloat(price.priceGroup.cost) >= minPriceGroupCost
                && parseFloat(price.priceGroup.cost) <= shop.cost
            ) {
                minPriceGroupCost = parseFloat(price.priceGroup.cost);
                cost = parseFloat(price.cost);
            }
        });

        return cost * count;
    }

    function renderItems(flags) {
        existProductGroup = {};

        var templateData = {
            items: [],
            exists_items: false,
            cost: 0,
            promocode_cost: 0
        };
        
        // если в корзине нет товаров кроме фотопечати  и указана сумма промокода (исп. при рассчете более выгодной скидки фотопечати)
        var usePromocodeProfitable = checkItemsUseProfitableSum();

        var promocodeValue = 0;
        var i, item, templateItem, cost, promocode_cost;
        for (i in orderData.items) {
            cost = 0;
            promocode_cost = 0;
            item = data.items[i];
            templateItem = {
                id: item.id,
                name: item.name,
                count: orderData.items[i],
                cost: 0,
                description: item.description !== null ? item.description.split('\r\n').join('<br>') : '',
                is_readonly_count: false,
                is_show_count: true,
                is_show_count_from_circulation: false,
                circulations: [],
            };

            switch (parseInt(item.product_group_id)) {
                case SOUVENIR_PRODUCT_GROUP:
                    cost = getSouvenirCost(item.data, templateItem.count);
                    templateItem.circulations = getSouvenirCirculations(item.data, templateItem.count);

                    if (templateItem.circulations.length > 1) {
                        templateItem.is_show_count_from_circulation = true;
                        templateItem.is_show_count = false;
                    }

                    break;
                case PHOTOBOOK_PRODUCT_GROUP:
                    cost = item.amount * templateItem.count;
                    break;
                case DESIGNBOOK_PRODUCT_GROUP:
                    templateItem.is_readonly_count = true;
                    templateItem.is_show_count = false;
                    cost = parseFloat(item.amount);

                    const bookDesignProject = data.bookdesign.projects[item.data.project_id];
                    if (!_.isObject(bookDesignProject)) {
                        self.dialog.show('message', {message: Yii.t('Can not find bookdesign project') +' <br>' + item.name.split('\r\n').join('<br>')});
                    }
                    
                    templateItem.designbook = {};

                    if (_.isObject(bookDesignProject)) {
                        templateItem.designbook.viewLink =
                            window.requestUrl.designer.view +
                            bookDesignProject.id +
                            '_' +
                            bookDesignProject.hash;

                        templateItem.designbook.editLink =
                            window.requestUrl.designer.edit +
                            bookDesignProject.id +
                            '_' +
                            bookDesignProject.hash;
                    }

                    break;
                case PHOTOPRINT_PRODUCT_GROUP:
                    var project = data.photo.projects[item.data.project_id];
                    if (!_.isObject(project)) {
                        self.dialog.show('message', {message: Yii.t('Can not find photo project') +' <br>' + item.name.split('\r\n').join('<br>')});
                    }

                    templateItem.name = item.name.split('\r\n').join('<br>');
                    templateItem.is_show_count = false;
                    templateItem.is_show_link = true;
                    if (_.isObject(project)) {
                        templateItem.link = '/photoprint/#' + project.id + '_' + project.hash;
                    }

                    cost = getPhotoprintCost(item.data.project_id);
                    break;
                case FILE_PRODUCT_GROUP:
                    templateItem.is_show_count = false;
                    break;
                case INTERIOR_PRODUCT_GROUP:
                    cost = item.amount * templateItem.count;
                    break;
                case INVOICE_PRODUCT_GROUP:
                    templateItem.is_show_count = false;
                    cost = item.amount * templateItem.count;
                    break;
                case SHOP_PRODUCT_GROUP:
                    templateItem.is_show_count = false;
                    templateItem.is_readonly_count = true;
                    cost = getShopProductCost(item.data, templateItem.count);
                    break;
            }

            var promocodeItem = getPromoCodeCost(promocodeValue, item, cost, usePromocodeProfitable);
            promocodeValue = promocodeItem.value;
            cost = promocodeItem.cost;

            existProductGroup[item.product_group_id] = true;

            templateItem.cost = cost.toFixed(2);
            templateData.items.push(templateItem);
            templateData.exists_items = true;
            templateData.cost += cost;

            templateData.promocode_cost += cost;
        }

        if (promocodeValue !== 0) {
            templateData.is_show_promocode_cost = true;
            templateData.promocode_cost -= promocodeValue;
        }

        if (templateData.promocode_cost < 0) {
            templateData.promocode_cost = 0;
        }

        templateData.cost = templateData.cost.toFixed(2);
        templateData.promocode_cost = templateData.promocode_cost.toFixed(2);

        var itemsContent = self.templater.render(templates.items, templateData);
        $('#items').html(itemsContent);

        var costContent = self.templater.render(templates.cost_1, templateData);
        $('#cost-1').html(costContent);

        if (templateData.items.length > 0) {
            $('#cost-wrapper').removeClass('hide');
        } else {
            $('#cost-wrapper').addClass('hide');
        }

        if (typeof flags === 'object' && flags.hasOwnProperty('showCount')) {
            var $el = $('.item:visible[data-id="' + flags.showCount + '"]');
            $el.find('.dropdown-toggle').dropdown('toggle');
            $el.find('.item-count').focus();
        }

        self.initTooltip();
    }

    function checkItemsUseProfitableSum() {
        if (parseInt(promocode.discount_value) === 0) {
            return true;
        }
        for (i in orderData.items) {
            item = data.items[i];
            if (item.product_group_id !== PHOTOPRINT_PRODUCT_GROUP) {
                return false;
            }
        }
        return true;
    }

    function getPercentBonus() {
        var percent = {
            income: 0,
            writeoff: 0
        };

        var i, item, amounts = [], collect = parseFloat(data.bonuses.collect);
        for (i in data.bonuses.percent) {
            item = data.bonuses.percent[i];
            if (collect >= parseFloat(item.amount)) {
                amounts.push(item.amount);
            }
        }

        if (amounts.length === 0) {
            return percent;
        }

        var amount = Math.max.apply(null, amounts);

        for (i in data.bonuses.percent) {
            item = data.bonuses.percent[i];
            if (amount === parseFloat(item.amount)) {
                percent = {
                    income: parseFloat(item.percent_income),
                    writeoff: parseFloat(item.percent_writeoff)
                };
                break;
            }
        }

        return percent;
    }

    function changeWriteOffBonus($element) {
        orderData.writeoff_bonus = $element.prop('checked') ? 1 : 0;
        renderCost2();
    }

    function renderPromocodes() {
        var templateData = {
            is_exist: parseInt(data.is_exist_promocodes) === 1,
            'user_promocode' : data.user_promocode
        };

        if (promocode !== false) {
            var item = $.extend(true, {}, promocode);

            if (parseInt(item.discount_percent) === 0) {
                item.discount = item.discount_value + ' ' + data.currency.short_name;
            } else {
                item.discount = item.discount_percent + ' %';
            }

            if (item.hasOwnProperty('description')) {
                item.promocode_desc = item.description;
            }

            templateData.item = item;
        }

        var html = self.templater.render(templates.promocodes, templateData);
        $('#promocode').html(html);
    }

    function renderPayments() {
        var templateData = {
            items: [],
            currency: data.currency,
        };

        var cost = getCost();
        var addressPayments = data.address_payments;
        var payments = data.payments;
        var deliveries = data.deliveries;
        var deliveryServices = data.delivery_services;
        var paymentChecked = false;

        var i, addressPayment, templateItem;
        for (i in addressPayments) {
            addressPayment = addressPayments[i];
            if (parseInt(addressPayment.address_id) !== parseInt(addressId)) {
                continue;
            }

            companyAddressPayments[addressPayment.payment_id] = addressPayment;

            templateItem = {
                id: addressPayment.payment_id,
                name: addressPayment.name,
                description: addressPayment.description,
                is_show: true
            };

            if (cost >= parseFloat(addressPayment.min_order_cost) && parseInt(addressPayment.min_order_cost) !== 0) {
                templateItem.is_show = false;
                templateItem.min_order_cost = addressPayment.min_order_cost;
            }

            if (deliveries.hasOwnProperty(deliveryData.id)) {
                var payment = payments[addressPayment.payment_id];

                if (parseInt(payment.is_online) === 0) {
                    var delivery = deliveries[deliveryData.id];
                    if (parseInt(delivery.only_online_payments) === 1) {
                        orderData.payment = 2;
                        continue;
                    }

                    if (deliveryServices.hasOwnProperty(deliveryData.service_id)) {
                        var deliveryService = deliveryServices[deliveryData.service_id];
                        if (parseInt(deliveryService.only_online_payments) === 1) {
                            orderData.payment = 2;
                            continue;
                        }
                    }
                }
            }

            if (orderData.payment === 0 && templateItem.is_show) {
                orderData.payment = addressPayment.payment_id;
            }

            if (parseInt(addressPayment.payment_id) === parseInt(orderData.payment)) {
                templateItem.is_checked = true;
                paymentChecked = true;
            }

            templateData.items.push(templateItem);
        }

        if(!paymentChecked){
            orderData.payment = 0;
            for (i in templateData.items) { 
                if (templateData.items[i].is_show) {
                    templateData.items[i].is_checked = true;
                    orderData.payment = templateData.items[i].id;
                    break;
                }
            }
        }

        var html = self.templater.render(templates.payments, templateData);
        $('.payment').html(html);
    }

    function renderUser() {
        var templateData = $.extend(true, {}, orderData.user);

        const delivery = data.deliveries[deliveryData.id];
        const fullNameRequired = delivery && Number(delivery.full_name_required);

        /** is_show_all_name === true - мы показываем одно единое поле ФИО */
        templateData.is_show_all_name = !fullNameRequired;
        templateData.show_recipient = parseInt(data.company.show_recipient) === 1;
        templateData.is_auth = !_.isEmpty(data.user);

        templateData.name = [];

        if (orderData.user.last_name) {
            templateData.name.push(orderData.user.last_name);
        }
        if (orderData.user.first_name) {
            templateData.name.push(orderData.user.first_name);
        }
        if (orderData.user.middle_name) {
            templateData.name.push(orderData.user.middle_name);
        }

        templateData.name = templateData.name.join(' ');

        var html = self.templater.render(templates.user, templateData);
        $('.user').html(html);
        $('input[name="phone"]').inputmask(data.country.phone_code + data.country.phone_format);
    }

    function renderDelivery() {
        var templateData = {};

        var i, item;
        for (i in data.deliveries) {
            item = data.deliveries[i];

            templateData[item.key] = {
                id: item.delivery_id,
                name: item.name,
                is_checked: item.delivery_id === deliveryData.id,
                description: item.description.replace(/(?:\r\n|\r|\n)/g, '<br>'),
                position: item.position
            };
        }

        if (templateData.hasOwnProperty('pickup')) {
            templateData.pickup_show_another_points = Object.keys(data.addresses).length > 1
            templateData.pickup_items = getDeliveryPickupPoints();
            templateData.pickup_cities = getDeliveryPickupCities();
            templateData.pickup_is_selected_point = deliveryData.point_id;
            if (deliveryData.point_id) {
                templateData.pickup_item = getDeliveryAddress(deliveryData.point_id);
            }
        }

        if (templateData.hasOwnProperty('points')) {
            templateData.points_items = getDeliveryPoints();
            templateData.points_countries = getDeliveryPointsCountries();
            templateData.show_select_countries = pointsCountries.length ? true : false;
            templateData.points_cities = getDeliveryCities();
            templateData.points_services = getDeliveryServices();
            templateData.points_is_selected_point = deliveryData.point_id;
            templateData.delivery_address = deliveryData.address;
            if (deliveryData.point_id) {
                templateData.points_item = getDeliveryPoint(deliveryData.point_id);
            }
        }

        if (templateData.hasOwnProperty('courier')) {
            templateData.regions = getCourierRegions();
            templateData.courier_services = getCourierServices();
            templateData.courier_cities = getCourierCities();
            templateData.show_courier_fields = parseInt(deliveryData.service_id) !== 0;
            templateData.show_service_delivery = parseInt(deliveryData.service_id) !== 1;
            templateData.show_region_delivery = parseInt(deliveryData.service_id) === 1;
        }

        templateData.user_address = getUserAddress();
        templateData.delivery_description = data.delivery_description;

        var html = self.templater.render(templates.delivery, templateData);
        $('.delivery').html(html);

        $('.js-delivery-city, .js-delivery-courier-city').select2({
            width : '100%'
        });
    }

    function getCourierServices() {
        var deliveries = [];

        deliveries.push({
            id: 0,
            name: Yii.t('Choose a courier company'),
            is_current: parseInt(deliveryData.service_id) === 0
        });

        if (
            data.delivery_services.hasOwnProperty(PHOTOCENTER_SERVICE_ID)
            && parseInt(data.delivery_services[PHOTOCENTER_SERVICE_ID].courier_enabled)
        ) {
            deliveries.push({
                id: PHOTOCENTER_SERVICE_ID,
                name: Yii.t('Photo center courier'),
                is_current: parseInt(deliveryData.service_id) === 1
            });
        }

        var i, item, items = {};
        for (i in data.points) {
            item = data.points[i];
            items[item.service_id] = true;
        }

        for (i in items) {
            item = data.delivery_services[i];

            if (!parseInt(item.courier_enabled) || !parseInt(item.enabled)) {
                continue;
            }

            deliveries.push({
                id: i,
                name: data.delivery_services[i].name,
                is_current: deliveryData.service_id === i
            });
        }

        return deliveries;
    }

    function getCourierCities() {
        var cities = [];

        var i, point, items = {};
        for (i in data.points) {
            point = data.points[i];

            if (parseInt(point.service_id) !== parseInt(deliveryData.service_id)) {
                continue;
            }

            items[point.city] = point.id;
        }

        for (i in items) {
            item = items[i];
            cities.push({
                name: i,
                point_id: item.split('_')[1],
                is_current: deliveryData.city === i
            });
        }

        cities.sort(function (a, b) {
            if (a.name < b.name) {
                return -1;
            }

            if (a.name === b.name) {
                return 0;
            }

            return 1;
        });

        return cities;
    }

    function getDeliveryServices() {
        var deliveries = [];

        deliveries.push({
            id: 0,
            name: Yii.t('All pickup points'),
            is_current: parseInt(deliveryData.service_id) === 0
        });

        var i, item, items = {};
        for (i in data.points) {
            item = data.points[i];

            if (deliveryData.city !== item.city) {
                continue;
            }

            items[item.service_id] = true;
        }

        for (i in items) {
            deliveries.push({
                id: i,
                name: data.delivery_services[i].name,
                is_current: deliveryData.service_id === i
            });
        }

        return deliveries;
    }

    function getDeliveryPickupCities() {
        var cities = [];

        var i, point, items = {};
        for (i in data.addresses) {
            point = data.addresses[i];
            items[point.city0.name] = true;
        }

        for (i in items) {
            cities.push({
                name: i,
                is_current: deliveryData.city === i
            });
        }

        cities.sort(function (a, b) {
            if (a.name < b.name) {
                return -1;
            }

            if (a.name === b.name) {
                return 0;
            }

            return 1;
        });

        return cities;
    }

    function getDeliveryCities() {
        var cities = [];
        var i, point, items = {};
        for (i in data.points) {
            point = data.points[i];
            items[point.city] = {
                country: point.country ? point.country : ''
            };
        }

        for (i in items) {
            if (pointsCountries.length && deliveryData.country !== items[i].country) {
                continue;
            }

            cities.push({
                name: i,
                is_current: deliveryData.city === i
            });
        }

        cities.sort(function (a, b) {
            if (a.name < b.name) {
                return -1;
            }

            if (a.name === b.name) {
                return 0;
            }

            return 1;
        });

        return cities;
    }

    function getDeliveryPickupPoints() {
        var points = [];

        var i, point;
        for (i in data.addresses) {
            point = data.addresses[i];

            if (deliveryData.city !== point.city0.name) {
                continue;
            }

            points.push({
                id: point.id,
                name: point.name,
                city: point.city0.name,
                work_time: point.comment,
                address: point.address,
                descript: '',
                service_id: 0,
                latitude: point.latitude,
                longitude: point.longitude,
                is_current: point.id === deliveryData.point_id
            });
        }

        return points;
    }

    function getDeliveryPoints() {
        var points = [];

        var i, point;
        for (i in data.points) {
            point = data.points[i];

            if (deliveryData.city !== point.city) {
                continue;
            }

            if (deliveryData.service_id !== point.service_id && parseInt(deliveryData.service_id) !== 0) {
                continue;
            }
            
            if (point.address.toUpperCase().indexOf(deliveryData.address.toUpperCase()) === -1) {
                continue;
            }
    
            point.name = data.delivery_services[point.service_id].name;
            point.color = data.delivery_services[point.service_id].color;
            point.is_current = point.id === deliveryData.point_id;

            points.push(point);
        }

        return points;
    }

    function getDeliveryPointsCountries() {
        let countries = [];
        let items = {};
        let i, point;

        for (i in data.points) {
            point = data.points[i];

            if (!point.country) {
                return [];
            }

            items[point.country] = {
                name: point.country,
            };
        }

        for (i in items) {
            countries.push({
                value: i,
                name: data.pointsCountriesLabels[i] ? data.pointsCountriesLabels[i] : i,
                is_current: deliveryData.country === i
            });
        }

        return countries;
    }

    function getDeliveryAddress(value) {
        var point;
        if (data.addresses.hasOwnProperty(value)) {
            point = data.addresses[value];

            return {
                id: point.id,
                name: point.name,
                city: point.city0.name,
                work_time: point.comment,
                address: point.address,
                descript: '',
                latitude: point.latitude,
                longitude: point.longitude
            };
        }
    }

    function getDeliveryPoint(value) {
        var point;

        if (data.points.hasOwnProperty(value)) {
            point = data.points[value];
            point.name = data.delivery_services[point.service_id].name;

            return point;
        }
    }

    function getCourierRegions() {
        var items = [];

        var i, item;
        for (i in data.courier_regions) {
            item = data.courier_regions[i];

            items.push({
                id: item.id,
                name: item.name,
                cost: item.cost,
                is_current: parseInt(deliveryData.region_id) === parseInt(item.id)
            });
        }

        return items;
    }

    function renderMargins() {
        orderData.margins = {};

        if (data.points.hasOwnProperty(deliveryData.point_id) && deliveryData.point_id !== 0) {
            $('.margins-wrapper').addClass('hide').empty();
            return false;
        }

        var templateData = {
            exists_margins: false,
            exists_margins_photobook: false,
            exists_margins_designbook: false,
            exists_margins_souvenir: false,
            exists_margins_photoprint: false,
            exists_margins_interior: false,
            exists_margins_file: false,
            margins_photobook: [],
            margins_designbook: [],
            margins_souvenir: [],
            margins_photoprint: [],
            margins_interior: [],
            margins_file: []
        };

        var margins = _.toArray(data.margins);

        margins.sort(function (a, b) {
            if (parseInt(a.position) < parseInt(b.position)) {
                return -1;
            }

            if (parseInt(a.position) === parseInt(b.position)) {
                return 0;
            }

            return 1;
        });

        var i, item, templateItem;
        for (i in margins) {
            templateData.exists_margins = true;
            item = margins[i];

            if (parseInt(item.address_id) === parseInt(addressId) || item.address_id === null) {
                templateItem = {
                    id: item.id,
                    // name: item.name + (parseInt(item.percent) !== 0 ? ' (+' + item.percent + '%)' : ''),
                    name: item.name,
                    description: item.description,
                    is_checked: false
                };

                switch (parseInt(item.product_group_id)) {
                    case PHOTOBOOK_PRODUCT_GROUP:
                        if (!existProductGroup.hasOwnProperty(item.product_group_id)) {
                            continue;
                        }

                        templateData.exists_margins_photobook = true;
                        orderData.margins[item.product_group_id] = 0;
                        templateData.margins_photobook.push(templateItem);
                        break;
                    case DESIGNBOOK_PRODUCT_GROUP:
                        if (!existProductGroup.hasOwnProperty(item.product_group_id)) {
                            continue;
                        }

                        templateData.exists_margins_designbook = true;
                        orderData.margins[item.product_group_id] = 0;
                        templateData.margins_designbook.push(templateItem);
                        break;
                    case SOUVENIR_PRODUCT_GROUP:
                    case CALENDAR_PRODUCT_GROUP:
                    case POLYGRAPHY_PRODUCT_GROUP:
                        if (!existProductGroup.hasOwnProperty(SOUVENIR_PRODUCT_GROUP)) {
                            continue;
                        }

                        templateData.exists_margins_souvenir = true;
                        orderData.margins[SOUVENIR_PRODUCT_GROUP] = 0;
                        templateData.margins_souvenir.push(templateItem);
                        break;
                    case PHOTOPRINT_PRODUCT_GROUP:
                        if (!existProductGroup.hasOwnProperty(item.product_group_id)) {
                            continue;
                        }

                        templateData.exists_margins_photoprint = true;
                        orderData.margins[item.product_group_id] = 0;
                        templateData.margins_photoprint.push(templateItem);
                        break;
                    case INTERIOR_PRODUCT_GROUP:
                        if (!existProductGroup.hasOwnProperty(item.product_group_id)) {
                            continue;
                        }

                        templateData.exists_margins_interior = true;
                        orderData.margins[item.product_group_id] = 0;
                        templateData.margins_interior.push(templateItem);
                        break;
                    case FILE_PRODUCT_GROUP:
                        if (!existProductGroup.hasOwnProperty(item.product_group_id)) {
                            continue;
                        }

                        templateData.exists_margins_file = true;
                        orderData.margins[item.product_group_id] = 0;
                        templateData.margins_file.push(templateItem);
                        break;
                    case INVOICE_PRODUCT_GROUP:
                        if (!existProductGroup.hasOwnProperty(item.product_group_id)) {
                            continue;
                        }

                        templateData.exists_margins_file = true;
                        orderData.margins[item.product_group_id] = 0;
                        templateData.margins_file.push(templateItem);
                        break;
                    case SHOP_PRODUCT_GROUP:
                        if (!existProductGroup.hasOwnProperty(item.product_group_id)) {
                            continue;
                        }

                        templateData.exists_margins_file = true;
                        orderData.margins[item.product_group_id] = 0;
                        templateData.margins_file.push(templateItem);
                        break;
                    default:
                        if (existProductGroup.hasOwnProperty(PHOTOBOOK_PRODUCT_GROUP)) {
                            orderData.margins[PHOTOBOOK_PRODUCT_GROUP] = 0;
                            templateData.exists_margins_photobook = true;
                            templateData.margins_photobook.push(templateItem);
                        }

                        if (existProductGroup.hasOwnProperty(DESIGNBOOK_PRODUCT_GROUP)) {
                            orderData.margins[DESIGNBOOK_PRODUCT_GROUP] = 0;
                            templateData.exists_margins_designbook = true;
                            templateData.margins_designbook.push(templateItem);
                        }

                        if (existProductGroup.hasOwnProperty(SOUVENIR_PRODUCT_GROUP)) {
                            orderData.margins[SOUVENIR_PRODUCT_GROUP] = 0;
                            templateData.exists_margins_souvenir = true;
                            templateData.margins_souvenir.push(templateItem);
                        }

                        if (existProductGroup.hasOwnProperty(PHOTOPRINT_PRODUCT_GROUP)) {
                            orderData.margins[PHOTOPRINT_PRODUCT_GROUP] = 0;
                            templateData.exists_margins_photoprint = true;
                            templateData.margins_photoprint.push(templateItem);
                        }

                        if (existProductGroup.hasOwnProperty(INTERIOR_PRODUCT_GROUP)) {
                            orderData.margins[INTERIOR_PRODUCT_GROUP] = 0;
                            templateData.exists_margins_interior = true;
                            templateData.margins_interior.push(templateItem);
                        }

                        if (existProductGroup.hasOwnProperty(FILE_PRODUCT_GROUP)) {
                            orderData.margins[FILE_PRODUCT_GROUP] = 0;
                            templateData.exists_margins_file = true;
                            templateData.margins_file.push(templateItem);
                        }

                        if (existProductGroup.hasOwnProperty(INVOICE_PRODUCT_GROUP)) {
                            orderData.margins[INVOICE_PRODUCT_GROUP] = 0;
                            templateData.exists_margins_file = true;
                            templateData.margins_file.push(templateItem);
                        }

                        if (existProductGroup.hasOwnProperty(SHOP_PRODUCT_GROUP)) {
                            orderData.margins[SHOP_PRODUCT_GROUP] = 0;
                            templateData.exists_margins_file = true;
                            templateData.margins_file.push(templateItem);
                        }
                }
            }
        }

        // if (templateData.margins_photobook.length > 0) {
        //     templateData.margins_photobook[0].is_checked = true;
        // }

        // if (templateData.margins_designbook.length > 0) {
        //     templateData.margins_designbook[0].is_checked = true;
        // }

        // if (templateData.margins_souvenir.length > 0) {
        //     templateData.margins_souvenir[0].is_checked = true;
        // }

        // if (templateData.margins_interior.length > 0) {
        //     templateData.margins_interior[0].is_checked = true;
        // }

        // if (templateData.margins_file.length > 0) {
        //     templateData.margins_file[0].is_checked = true;
        // }

        if (templateData.exists_margins) {
            var html = self.templater.render(templates.margins, templateData);
            $('.margins-wrapper').removeClass('hide').html(html);
        } else {
            $('.margins-wrapper').addClass('hide');
        }
    }

    function renderNumber() {
        var templateData = {
            url: document.domain,
            number: orderNumber,
            mail: orderData.user.email
        };

        if (parseInt(orderData.payment) === CARD_PAYMENT_ID) {
            templateData.payment = data.payments[orderData.payment];
        }

        self.dialog.show('number', templateData);
    }

    function renderUseSamples() {
        var templateData = {
            is_use_samples: false
        };

        templateData.send_sms = orderData.send_sms === 1;
        templateData.send_action_emails = orderData.send_action_emails === 1;
        templateData.sms_enable = parseInt(data.company.sms_enable) === 1;
        templateData.accept_rules = orderData.accept_rules === 1;

        if (parseInt(data.company.use_order_samples) === 1) {
            templateData.is_use_samples = true;
            templateData.use_smaples = orderData.use_samples === 1;
        }

        var html = self.templater.render(templates.use_samples, templateData);
        $('.use-order-samples').html(html);
    }

    function changeAddress(value, serviceId) {
        deliveryData.service_id = serviceId;

        if (deliveryData.id === PICKUP_DELIVERY_ID) {
            addressId = value;
            deliveryData.point_id = value;
        } else {
            addressId = data.address_id;
            deliveryData.point_id = value;
        }

        renderDelivery();
        renderMargins();
        renderPayments();
        renderCost2();
        renderUser();
        checkUserInfo();
    }

    function changeMargins(groupId, value) {
        orderData.margins[groupId] = value;
        renderPayments();
        renderCost2();
    }

    function changeUserInfo(element) {
        var key = element.attr('name');
        var value = element.val();

        if (key === 'name') {
            var names = value.split(' ');

            if (names.length <= 1) {
                orderData.user.first_name = value;
                orderData.user.last_name = '';
                orderData.user.middle_name = '';
            } else {
                orderData.user.last_name = names[0] || '';
                orderData.user.first_name = names[1] || '';
                orderData.user.middle_name = names[2] || '';
            }
        }

        orderData.user[key] = value;

        if (key === 'phone') {
            orderData.user.phone = value.replace(/[-+ ()_]/g, '');
        }

        checkInfo();
    }

    function setDelivery(options) {
        deliveryData.id = options.id || 0;
        deliveryData.region_id = options.region_id || 0;
        deliveryData.service_id = options.service_id || 0;
        deliveryData.point_id = options.point_id || 0;
        deliveryData.city = options.city || '';
        deliveryData.country = options.country || '';
        deliveryData.countries = [];
        deliveryData.address =  options.address || '';

        if (deliveryData.id === COURIER_DELIVERY_ID && deliveryData.region_id === 0 && deliveryData.service_id === PHOTOCENTER_SERVICE_ID) {
            deliveryData.region_id = Object.keys(data.courier_regions)[0];
        }

        if (deliveryData.id === COURIER_DELIVERY_ID && deliveryData.city === '') {
            deliveryData.city = data.city_name;
        }

        if (deliveryData.id === PICKUP_DELIVERY_ID && deliveryData.city === '') {
            deliveryData.city = data.city_name;
            deliveryData.service_id = 0;
            //deliveryData.point_id = data.address_id;
        }

        if (deliveryData.id === POINTS_DELIVERY_ID && deliveryData.country === '' && deliveryData.city === '') {
            deliveryData.country = pointsCountries[0] ? pointsCountries[0].value : '';
            deliveryData.service_id = 0;
        }

        if (deliveryData.id === POINTS_DELIVERY_ID && deliveryData.city === '') {
            const point = findDeliveryPoint({
                city: data.seo_city,
                country: deliveryData.country,
            });

            if (point) {
                deliveryData.city = point.city;
            } else {
                let firstPoint =  findFirstPoint({
                    country : deliveryData.country
                });

                deliveryData.city = firstPoint ? firstPoint.city : '';
            }

            deliveryData.service_id = 0;
        }

        if (deliveryData.id !== PICKUP_DELIVERY_ID) {
            addressId = data.address_id;
        }
    }

    function findFirstPoint (options) {
        var options = Object.assign({}, {
            country: '', 
        }, options);

        var i, point;
        for (i in data.points) {
            point = data.points[i];
            if (point.country === options.country) {
                return point;
            }
        }

        return false;
    }

    function findDeliveryPoint(options) {
        var options = Object.assign({}, {
            city: '', 
            country: '',
        }, options);

        var i, point;
        for (i in data.points) {
            point = data.points[i];
            point.country = (point.country === null) ? '' : point.country;

            if (!options.country) {
                if (point.city === options.city) {
                    return point;
                }
            }
            if (point.city === options.city && point.country === options.country) {
                return point;
            }
        }

        return false;
    }

    function changeDelivery(options) {
        setDelivery(options);
        renderDelivery();
        renderPayments();
        checkInfo();
        renderMargins();
        renderCost2();
        renderUser();
        checkUserInfo();
    }

    function initMap(id, deliveryId) {
        self.dialog.show('map');

        var point = {};
        var points = [];
        if (deliveryId === PICKUP_DELIVERY_ID) {
            points = getDeliveryPickupPoints();
            point = getDeliveryAddress(id);
        }

        if (deliveryId === POINTS_DELIVERY_ID) {
            points = getDeliveryPoints();
            point = getDeliveryPoint(id);
        }

        if (!window.hasOwnProperty('ymaps') && !window.hasOwnProperty('google')) { //! check
            return;
        }

        const mapType = parseInt($("#point-map").attr('data-type'));
        currentMapType = (mapType === YANDEX_MAP_TYPE || mapType === GOOGLE_MAP_TYPE) ? mapType : YANDEX_MAP_TYPE;

        if (currentMapType === YANDEX_MAP_TYPE) {
            initYandexMap(points, point)
        }

        if (currentMapType === GOOGLE_MAP_TYPE) {
            initGoogleMap(points, point)
        }
    }

    let markers = [];
    let cluster;
    let currentWindow;

    function initGoogleMap(points, point) {
        if (cluster) {
            cluster.clearMarkers();
            setMapOnAll(null)
        }

        window.googleMap = new google.maps.Map(document.getElementById("point-map"), {
            center: { lat: parseFloat(point.latitude), lng: parseFloat(point.longitude) },
            zoom: 6,
        });

        markers = [];

        let  currentMarker, i = 0;

        _.forEach(points, function (item) {

            var content = '<div class="content">';
            content += `<h4>${item.name}</h4>`;

            content += `${item.city} , ${item.address}`;

            if (item.descript) {
                content += item.descript;
            }

            if (item.work_time) {
                content += item.work_time;
            }

            content += "</div><br>";
            content += '<button class="btn btn-success js-delivery-point" data-id="' + item.id + '" data-service="' + item.service_id + '">' + Yii.t('Choose') + '</button>';

            const marker = new google.maps.Marker({
                position: new google.maps.LatLng(parseFloat(item.latitude), parseFloat(item.longitude)),
                map: window.googleMap,
            });
    
            const infoWindow = new google.maps.InfoWindow({
                content: content,
                ariaLabel: item.name,
            });
    
            markers.push(marker);
    
            google.maps.event.addListener(marker, 'click', function () {
                if (currentWindow) {
                    currentWindow.close()
                }
                infoWindow.open(window.googleMap, marker);
            });

            if (item.id === point.id) {
                currentMarker = marker;
                currentWindow = infoWindow;
            }

            i++;
        });

        cluster = new markerClusterer.MarkerClusterer({ markers, map: window.googleMap});

        if (currentMarker) {
            window.googleMap.setZoom(17);
            window.googleMap.panTo(currentMarker.position);
            currentWindow.open(window.googleMap, currentMarker);
        }
    }

    function setMapOnAll(map) {
        for (var i = 0; i < markers.length; i++) {
          markers[i].setMap(map);
        }
    }

    function initYandexMap(points, point) {
        if (window.map) {
            window.map.destroy();
        }

        window.map = new window.ymaps.Map("point-map", {
            center: [point.latitude, point.longitude],
            zoom: 9,
            controls: ['zoomControl']
        });

        // window.map.behaviors.disable("scrollZoom");

        clusterer = new window.ymaps.Clusterer({
            hasHint: false,
            clusterDisableClickZoom: true,
        });

        const geoObjects = [];

        let currentPoint, i = 0;

        _.forEach(points, function (item) {

            var content = item.city + ', ' + item.address;

            if (item.descript) {
                content += '<br>' + item.descript;
            }

            if (item.work_time) {
                content += '<br>' + item.work_time;
            }

            var placemark = new ymaps.Placemark(
                [item.latitude, item.longitude],
                {
                    balloonContentHeader: item.name,
                    balloonContentBody: content,
                    balloonContentFooter: '<button class="btn btn-success js-delivery-point" data-id="' + item.id + '" data-service="' + item.service_id + '">' + Yii.t('Choose') + '</button>'
                },
            );
            if (item.id === point.id) {
                currentPoint = i;
            }

            geoObjects[i] = placemark;

            i++;
        });

        clusterer.options.set({
            gridSize: 80,
            clusterDisableClickZoom: true
        });

        clusterer.add(geoObjects);
        window.map.geoObjects.add(clusterer);

        window.map.setBounds(clusterer.getBounds());

        const objectState = clusterer.getObjectState(geoObjects[currentPoint]);
        if (objectState.isClustered) {
            objectState.cluster.state.set('activeObject', geoObjects[currentPoint]);
            clusterer.balloon.open(objectState.cluster);
        } else if (objectState.isShown) {
            geoObjects[currentPoint].balloon.open();
        }
    }

    function changePayment(value) {
        orderData.payment = value;
        renderCost2();
    }

    function changeComment(value) {
        orderData.comment = value;
    }

    function changeUseSamples($element) {
        orderData.use_samples = $element.prop('checked') ? 1 : 0;
    }

    function changeSendSms($element) {
        orderData.send_sms = $element.prop('checked') ? 1 : 0;
    }

    function changeAcceptRules($element) {
        orderData.accept_rules = $element.prop('checked') ? 1 : 0;
    }

    function changeSendActionEmails($element) {
        orderData.send_action_emails = $element.prop('checked') ? 1 : 0;
    }

    function changeDeliveryIsFragile($element) {
        orderData.delivery_is_fragile = $element.prop('checked') ? 1 : 0;
        renderCost2();
    }

    function checkUserInfo() {
        var filter = /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i;

        var success = {};
        var fields = ['first_name', 'last_name', 'name', 'email', 'phone'];
        var i, field, $element;

        var isPhotocenter = false;
        if (data.addresses.hasOwnProperty(deliveryData.point_id)) {
            isPhotocenter = true;
        }

        var delivery = data.deliveries[deliveryData.id];
        var fullNameRequired = delivery && Number(delivery.full_name_required);

        for (i in fields) {
            field = fields[i];
            $element = $("input[name='" + field + "']");
            switch (field) {
                /** fullNameRequired === true - поле "name" не отображается и должно проходить валидацию */
                case 'name':
                    success[field] = fullNameRequired || ($element.length > 0 && $element.val().length > 1);
                    break;
                /** fullNameRequired === false - поля "first_name", "last_name" не отображаются
                 * и должны проходить валидацию */
                case 'first_name':
                case 'last_name':
                    success[field] = !fullNameRequired || ($element.length > 0 && $element.val().length > 1);
                    break;
                case 'email':
                    success[field] = filter.test($("input[name='email']").val());
                    break;
                case 'phone':
                    var phoneLength = $("input[name='phone']").val().replace(/[-+ ()_]/g, '').length;
                    success[field] = phoneLength === 10 || phoneLength === 11 || phoneLength === 12;
                    break;
            }

            if (success[field]) {
                $element.parents('.form-group').addClass('has-success').removeClass('has-error');
                $element.parents('.form-group').find('.glyphicon').addClass('glyphicon-ok').removeClass('glyphicon-cancel');
            } else {
                $element.parents('.form-group').removeClass('has-success').addClass('has-error');
                $element.parents('.form-group').find('.glyphicon').removeClass('glyphicon-ok').addClass('glyphicon-cancel');
            }
        }

        return !fullNameRequired
            ? success.name & success.email & success.phone
            : success.first_name & success.last_name & success.email & success.phone;
    }

    function checkDeliveryInfo() {
        var deliveryId = deliveryData.id;
        var serviceId = deliveryData.service_id;
        var fields = [];
        var success = true;

        switch (deliveryId) {
            case COURIER_DELIVERY_ID:
                fields = ['city', 'street', 'house1'];
                if (serviceId === PHOTOCENTER_SERVICE_ID) {
                    fields = ['street', 'house1'];
                }
                break;
            case MAILRUSSIA_DELIVERY_ID:
                fields = ['mailpost', 'city', 'street', 'house1'];
                break;
            case LATVIJASPASTS_DELIVERY_ID:
                fields = ['city', 'street', 'house1'];
                break;
            case NOVAPOSHTA_DELIVERY_ID:
                fields = ['postcode', 'city'];
                break;
        }

        var i, $element;
        for (i in fields) {
            $element = $("#delivery-method-" + deliveryId + " *[name='" + fields[i] + "']");
            if (!$element.val()) {
                success = false;
                $element.parents('.form-group').removeClass('has-success').addClass('has-error');
                $element.parents('.form-group').find('.glyphicon').removeClass('glyphicon-ok').addClass('glyphicon-cancel');
            } else {
                $element.parents('.form-group').addClass('has-success').removeClass('has-error');
                $element.parents('.form-group').find('.glyphicon').addClass('glyphicon-ok').removeClass('glyphicon-cancel');
            }
        }

        return success;
    }

    function checkInfo() {
        var userOk = checkUserInfo();
        var deliveryOk = checkDeliveryInfo();
        var infoOk = deliveryOk && userOk;

        if (infoOk) {
            $("#step" + step + " .js-next").removeClass('disabled');
        } else {
            $("#step" + step + " .js-next").addClass('disabled');
        }

        return infoOk;
    }

    function setCount(id, value) {
        value = parseInt(value);

        if (isNaN(value)) {
            value = 1;
        }

        if (value < 1) {
            value = 1;
        }

        orderData.items[id] = value;
    }

    function updateItem(id) {
        var data = {
            count: orderData.items[id]
        };

        $.ajax({
            url: '/shopcart/items/' + id,
            method: 'PUT',
            data: data,
        });
    }

    function removeItem(id) {
        self.dialog.show('confirm', {
            message: Yii.t('Are you sure you want to remove the product from the cart?'),
            continueEvent: 'app.shopcart.remove(' + id + ')'
        });
    }

    self.remove = function (id) {
        self.dialog.hide('confirm');
        self.loader.show(Yii.t('Removing a product'));

        $.ajax({
            url: '/shopcart/items/' + id,
            method: 'DELETE',
        }).done(function () {
            delete orderData.items[id];
            renderItems();
        }).fail(function () {
            self.dialog.show('message', {message: Yii.t('Deletion error ')});
        }).always(function () {
            self.loader.hide();
        });
    };

    function showStep() {
        switch (step) {
            case 1:
                renderItems();
                renderPromocodes();
                break;
            case 2:
                if (!checkMinCost() && !showMinCost) {
                    showMinCost = true;
                    self.dialog.show('min-cost', {message: Yii.t('Minimum order amount ') + data.company.min_cost + data.currency.short_name});
                    return false;
                }

                /** проверка на максимальное количество книг в заказе */
                if (!checkMaxCountBooks()) {
                    self.dialog.show('message', {
                        message: Yii.t(
                            'You have exceeded the maximum number of photo books in an order set by the production. The maximum number of books is {count}.',
                            { count: data.company.max_count_books_per_order }
                        ),
                    });
                    return false;
                }

                renderPayments();
                renderUser();
                renderMargins();
                renderCost2();
                checkInfo();
                renderUseSamples();
                renderDelivery();
                break;
        }

        $('.step').addClass('hide');
        $('#step' + step).removeClass('hide');

        return true;
    }

    function checkMinCost() {
        var minCost = parseFloat(data.company.min_cost);
        var cost = getCost();

        if (minCost > 0 && cost < minCost) {
            return false;
        }

        return true;
    }

    function checkMaxCountBooks() {
        const maxCountBooks = data.company.max_count_books_per_order;
        let countBooks = 0;

        if (!maxCountBooks) {
            return true;
        }

        for (i in orderData.items) {
            const item = data.items[i];
            const isBook = [
                PHOTOBOOK_PRODUCT_GROUP,
                DESIGNBOOK_PRODUCT_GROUP,
            ].includes(parseInt(item.product_group_id));

            if (!isBook) {
                continue;
            }

            countBooks += orderData.items[i];
        }

        if (countBooks > Number(maxCountBooks)) {
            return false;
        }

        return true;
    }

    function checkMargins() {
        if (!orderData.hasOwnProperty('margins')) {
            return true;
        }

        var i, margin;
        for (i in orderData.margins) {
            margin = orderData.margins[i];


            if (margin === 0) {
                return false;
            }
        }

        return true;
    }

    function getUserAddress() {
        var deliveryId = deliveryData.id;
        var address = {};
        var fields = [];

        switch (deliveryId) {
            case COURIER_DELIVERY_ID:
                fields = ['city', 'street', 'house1', 'house2', 'apartment'];
                break;
            case MAILRUSSIA_DELIVERY_ID:
                fields = ['mailpost', 'city', 'street', 'house1', 'house2', 'apartment'];
                break;
            case LATVIJASPASTS_DELIVERY_ID:
                fields = ['city', 'street', 'house1', 'house2', 'apartment'];
                break;
            case NOVAPOSHTA_DELIVERY_ID:
                fields = ['postcode', 'city', 'street', 'house1', 'house2', 'apartment'];
                break;
        }

        for (var i in fields) {
            address[fields[i]] = $("#delivery-method-" + deliveryId + " *[name='" + fields[i] + "']").val();
        }

        return address;
    }

    function addOrder() {
        if (!checkInfo()) {
            return false;
        }

        if (!checkMargins()) {
            self.dialog.show('message', {message: Yii.t('You must select the urgency')});
            return false;
        }

        orderData.user_address = getUserAddress();
        orderData.delivery = deliveryData;
        orderData.address_id = addressId;

        self.loader.show(Yii.t('Checkout'));
        $.post({url: '/order/items', data: orderData, dataType: 'json'})
            .done(function (response) {
                if (response.hasOwnProperty('errors')) {
                    self.dialog.show('message', {message: formatOrderErrors(response.errors)});
                    return;
                }

                step = 1;
                orderNumber = response.number;
                orderData.items = {};
                showStep();
                completeOrder();
            })
            .fail(function (jqXHR) {
                self.dialog.show('message', {message: getOrderErrorMessage(jqXHR)});
            })
            .always(function () {
                self.loader.hide();
            });
    }

    function formatOrderErrors(errors) {
        var messages = [];
        for (var i in errors) {
            messages.push(errors[i]);
        }
        return messages.join('<br/>');
    }

    function getOrderErrorMessage(jqXHR) {
        var response = jqXHR.responseJSON;

        if (response && response.errors) {
            return formatOrderErrors(response.errors);
        }

        if (response && response.message) {
            return response.message;
        }

        return Yii.t('An error occurred while placing an order. Please contact technical support');
    }

    function completeOrder() {
        // complete order for custom domains
        if (window.ym && window.ymCounters && window.ymCounters.mainID) {
            window.ym(window.ymCounters.mainID, 'reachGoal', 'CompleteOrder', {number: orderNumber});
        }

        if (window.ym && window.ymCounters && window.ymCounters.companyID) {
            window.ym(window.ymCounters.companyID, 'reachGoal', 'OrderСreated', {number: orderNumber});
        }

        if (data.payments[orderData.payment].key === 'online') {
            window.location = '/payment/online/' + orderNumber;
        } else {
            renderNumber();
        }
    }

    function checkPromocode(name) {
        self.loader.show(Yii.t('Checking the promo code'));
        $.post('/api/promocode/check', {name: name}, function (response) {
            if (response.hasOwnProperty('error')) {
                self.dialog.show('message', {message: response.error});
            } else {
                var cost = getCost();
                var minCost = parseFloat(response.promocode.min_cost);
                if (parseInt(minCost) !== 0 && minCost > cost) {
                    self.loader.hide();
                    self.dialog.show('message', {message: Yii.t('Minimum order amount to use promo code') + ' ' + minCost + ' ' + data.currency.short_name});
                    return false;
                }

                promocode = response.promocode;
                orderData.promocode = response.promocode.id;
                renderItems();
                renderPromocodes();
            }

            self.loader.hide();
        }, 'json');
    }

    function removePromocode(id) {
        promocode = false;
        orderData.promocode = 0;

        renderItems();
        renderPromocodes();
    }

    init();

    $(document).on('click', '.js-increase-count', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var id = $(this).parents('.item').attr('data-id');
        setCount(id, orderData.items[id] + 1);
        updateItem(id);
        renderItems({showCount: id});
    });

    $(document).on('click', '.js-decrease-count', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var id = $(this).parents('.item').attr('data-id');
        setCount(id, orderData.items[id] - 1);
        updateItem(id);
        renderItems({showCount: id});
    });

    $(document).on('change', '.js-set-count', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var id = $(this).parents('.item').attr('data-id');
        setCount(id, $(this).val());
        updateItem(id);
        renderItems({showCount: id});
    });

    $(document).on('click', '.js-remove-item', function () {
        var id = $(this).parents('.item').attr('data-id');
        removeItem(id);
    });

    $(document).on('click', '.js-previous', function () {
        if (!$(this).hasClass('disabled')) {
            step--;
            showStep();
        }
    });

    $(document).on('click', '.js-next', function () {
        if (!$(this).hasClass('disabled')) {
            step++;
            if (!showStep()) {
                step--;
            }
        }
    });

    $(document).on('keyup change', '.js-user-info', function () {
        changeUserInfo($(this));
    });

    $(document).on('click', '.js-delivery', function () {
        changeDelivery({
            id: $(this).attr('data-id')
        });
    });

    $(document).on('change', '.js-delivery-service', function () {
        changeDelivery({
            id: deliveryData.id,
            city: deliveryData.city,
            country: deliveryData.country,
            service_id: $(this).val()
        });
    });

    $(document).on('change', '.js-delivery-courier-service', function () {
        changeDelivery({
            id: deliveryData.id,
            city: deliveryData.city,
            service_id: $(this).val(),
        });
        $('.js-delivery-courier-city').trigger('change');
    });

    $(document).on('change', '.js-delivery-country-points', function () {
        changeDelivery({
            id: deliveryData.id,
            country: $(this).val(),
            city: '',
        });
    });

    $(document).on('change', '.js-delivery-city', function () {
        changeDelivery({
            id: deliveryData.id,
            city: $(this).val(),
            country: deliveryData.country
        });
    });

    $(document).on('change', '.js-delivery-courier-city', function () {
        changeDelivery({
            id: deliveryData.id,
            service_id: deliveryData.service_id,
            city: $(this).val(),
            point_id: $(this).find(':selected').data('point'),
        });
    });

    $(document).on('change', '.js-delivery-region', function () {
        changeDelivery({
            id: deliveryData.id,
            service_id: deliveryData.service_id,
            region_id: $(this).val()
        });
    });

    $(document).on('keyup change', '.js-search-by-address', function () {
        changeDelivery({
            id: deliveryData.id,
            city: deliveryData.city,
            country: deliveryData.country,
            service_id: deliveryData.service_id,
            address: $(this).val()
        });
        
        const input = $('.js-search-by-address');
        const tmp = input.val();
        input.focus().val("").blur().focus().val(tmp);
    });
  
    $(document).on('click', '.js-delivery-address', function () {
        changeAddress(
            $(this).attr('data-id'),
            $(this).attr('data-service')
        );
    });

    $(document).on('click', '.js-delivery-point', function () {
        if (window.hasOwnProperty('map') || window.hasOwnProperty('googleMap')) {
            self.dialog.hide('map');
        }
        changeAddress($(this).attr('data-id'), $(this).attr('data-service'));
    });

    $(document).on('click', '.js-show-points', function () {
        $('.js-selected-point').addClass('hide');
        $('.js-points').removeClass('hide')
    });

    $(document).on('keyup change', '.js-check-info', function () {
        var value = $(this).val();
        var name = $(this).attr('name');
        $('input[name="' + name + '"]').val(value);
        checkInfo();
    });

    $(document).on('click', '.js-change-payment', function () {
        changePayment($(this).val());
    });

    $(document).on('keyup change', '.js-change-comment', function () {
        changeComment($(this).val());
    });

    $(document).on('click', '.js-change-margins', function () {
        changeMargins($(this).attr('data-group'), $(this).val());
    });

    $(document).on('click', '.js-add-order', function () {
        addOrder();
    });

    $(document).on('click', '#js-check-promocode', function () {
        checkPromocode($('input[name="promocode"]').val());
    });

    $(document).on('click', '.js-remove-promocode', function () {
        removePromocode($(this).attr('data-id'));
    });

    $(document).on('click', '.js-use-samples', function () {
        changeUseSamples($(this));
    });

    $(document).on('click', '.js-send-sms', function () {
        changeSendSms($(this));
    });

    $(document).on('click', '.js-accept-rules', function () {
        changeAcceptRules($(this));
    });

    $(document).on('click', '.js-send-action-emails', function () {
        changeSendActionEmails($(this));
    });

    $(document).on('click', '.js-writeoff-bonus', function () {
        changeWriteOffBonus($(this));
    });

    $(document).on('click', '.js-show-map', function () {
        initMap($(this).attr('data-id'), $(this).attr('data-delivery-id'))
    });

    $(document).on('click', '.js-delivery-is-fragile', function () {
        changeDeliveryIsFragile($(this));
    });
};

if (window.hasOwnProperty('app')) {
    app.initModule('shopcart', window.appModules.Shopcart);
}
